import './dist/App.css'
import Hero from './components/Hero'
import Content from './components/Content'
import Footer from './components/Footer'
import Contact from './components/Contact'
import Access from './components/Access'

function App() {
	return <div className="App">
			<Hero />

			<Content />

			<Access />

			<Contact />

			<Footer />
	</div>
}

export default App;
